module.exports = __webpack_public_path__ + "media/images/new-ui-images/select-cross-ff7ddd5f7d5eff257867194e7bc9ffd1.svg";